/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum SuspendItemAliases {
  AUTOCOMPLETE_ITEM_SUSPEND_REASON = 'autocomplete-item-suspend-reason',
  CONTEXTUAL_BAR_SUSPEND_ITEM = 'contextual-bar-suspend-item',
  DOSE_EXECUTED_FIELD = 'dose-executed-field',
  DOSE_EXECUTED_TEXT = 'dose-executed-text',
  FETCH_SUSPEND_ITEM_REASON = 'fetch-suspend-item-reason',
  FIELD_ADMINISTRATION_ROUTE_TYPE = 'field-administration-route-type',
  FIELD_CURRENT_TIME = 'field-current-time',
  FIELD_REASON = 'field-reason',
  FIELD_TEXT_AREA_JUSTIFICATION = 'field-text-area-justification',
  FORM_SUSPEND_ITEM = 'form-suspend-item',
  INFORMATION_BAR = 'information-bar',
  INPUT_CURRENT_TIME = 'input-current-time',
  LAYOUT_SUSPEND_ITEM = 'layout-suspend-item',
  LAYOUT_SUSPEND_ITEM_CONTENT = 'layout-suspend-item-content',
  MAPPER_ITEM_SUSPEND_REASON = 'mapper-item-suspend-reason',
  PANEL_SUSPEND_ITEM = 'panel-suspend-item',
  PANEL_SUSPEND_ITEM_CONTENT = 'panel-suspend-item-content',
  SUSPEND_ITEM_HEADER = 'suspend-item-header',
  TEXT_ADMINISTRATION_ROUTE_TYPE = 'text-administration-route-type',
  TEXT_AREA_JUSTIFICATION = 'text-area-justification',
  TEXT_ITEM_SUSPEND_REASON = 'text-item-suspend-reason',
  UNITY_EXECUTED_FIELD = 'unity-executed-field',
  UNITY_EXECUTED_TEXT = 'unity-executed-text',
}
export { SuspendItemAliases };
